export default __webpack_public_path__ + "static/media/align-center.c303b834.svg";